import { Component, OnInit, OnDestroy }       from '@angular/core';
import { Router }          from '@angular/router';
import { MessageService }  from './message.service';
import { Notice }          from '../notice/notice.service';
import { SERVER }          from '../app.constants';
import $ from 'jquery';


@Component({
    selector: 'app-messages',
    templateUrl:  './message.component.html'
 })
export class MessageComponent implements OnInit, OnDestroy  {

    //noticeSocket: any;
    

    constructor(
        public router: Router,
        public messageService: MessageService
    ) { }


    ngOnInit() {
        /*
        this.noticeSocket = new WebSocket(SERVER.socketURL + '/notice/');
        this.noticeSocket.addEventListener("message", (event) => {
            var data = JSON.parse(event.data);
            var notice: Notice = data['notice'];
            this.messageService.noticeList.push(notice);
        });
        */
    }


    moveToNoticePage(notice: Notice) {
        $('#noticeModal .modal-title').text(notice.title);
        $('#noticeModal .modal-body').html(notice.content);
        $('#noticeModal').modal('show');
    }


    ngOnDestroy() {
        //this.noticeSocket.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/common/message.component.ts